import api from '@/utils/api';

const controller = 'v1.0/configuracaoCallbackParceiro';
const configuracaoCallbackParceiroExport = Object.assign(
    {},
    api.GetCrud(controller, ["none"]),
    {
        CadastroCallbackParceiro: function (model) {
            return api.Axios.Post(controller, model);
        },
        AtualizarCallbackParceiro: function (model) {
            return api.Axios.PutWithoutId(controller, model);
        },
        AlterarStatusConfiguracaoParceiro:function(id, param){
            return api.Axios.Patch(controller + "/Altera_Status?codigo=" + id +"&status=" + param)
        },
        GetById: function (id) {
            return api.Axios.Get(controller + "/" + id);
        },
        GetTodos: function () {
            return api.Axios.Get(controller + "/Todos");
        },
        Delete: function (id) {
            return api.Axios.Delete(controller + "/" + id);
        },
    }
);

export default configuracaoCallbackParceiroExport;